<template>
    <aside class="aside col-xs-3 col-sm-3">
        <div class="aside__item">
            <ul id="main-menu" class="menu menu_top menu_icon-styled menu_accordion aside__menu"
                data-accordion-single>
                <li>
                    <a href="/finance">
                        <span class="cap-icon cap-icon-wallet"></span>
                        <span>{{$t('Счета')}}</span>
                    </a>
                </li>
                <li class="badged-menu-item">
                    <a href="/cards">
                        <span class="cap-icon cap-icon-card"></span>
                        <span class="caption">{{$t('Карты')}}</span>
                        <span class="capitalist-icon-badge-new"></span>
                    </a>
                </li>
                <li>
                    <a href="/finance/templates">
                        <span class="cap-icon cap-icon-documents"></span>
                        <span>{{$t('Шаблоны')}}</span>
                    </a>
                </li>

                <li>
                    <a href="/finance/payout">
                        <span class="cap-icon cap-icon-paper-plane"></span>
                        <span>{{$t('Переводы')}}</span>
                    </a>
                </li>
                <li>
                    <a href="/finance/transfers:mass">
                        <span class="cap-icon cap-icon-masspayment"></span>
                        <span>{{$t('Массовый платеж')}}</span>
                    </a>
                </li>
                <li>
                    <a href="/finance/deposit">
                        <span class="cap-icon cap-icon-money-add"></span>
                        <span>{{$t('Пополнение счета')}}</span>
                    </a>
                </li>
                <li>
                    <a href="/finance/exchange">
                        <span class="cap-icon cap-icon-money-exchange"></span>
                        <span>{{$t('Конвертация')}}</span>
                    </a>
                </li>
                <li>
                    <a href="/cheques">
                        <span class="cap-icon cap-icon-bill"></span>
                        <span>{{$t('Электронные чеки')}}</span>
                    </a>
                </li>

                <li>
                    <a href="/finance/history">
                        <span class="cap-icon cap-icon-clock"></span>
                        <span>{{$t('История операций')}}</span>
                    </a>
                </li>

                <li>
                    <router-link to="/merchants">
                        <span class="cap-icon cap-icon-payment"></span>
                        <span>{{$t('Прием платежей')}}</span>
                    </router-link>
                </li>

                <li class="badged-menu-item">
                    <a href="/services">
                        <span class="capitalist-icon-services side-menu-icon"></span>
                        <span class="caption">{{$t('Маркетплейс')}}</span>
                    </a>
                </li>

                <li class="services-menu-item">
                    <router-link to="/test">
                        <span class="capitalist-icon-services side-menu-icon"></span>
                        <span class="caption">Test</span>
                    </router-link>
                </li>
                <li class="services-menu-item">
                    <router-link to="/index">
                        <span class="capitalist-icon-services side-menu-icon"></span>
                        <span class="caption">Index</span>
                    </router-link>
                </li>
            </ul>
        </div>
        <currency-rates/>
        <sales-department v-if="false"></sales-department>
        <aside-referral-banner></aside-referral-banner>
        <aside-news></aside-news>

    </aside>
</template>

<script>
import CurrencyRates from '@/views/layouts/sidemenu/CurrencyRates';
import SalesDepartment from '@/views/layouts/sidemenu/SalesDepartment';
import AsideNews from '@/views/layouts/sidemenu/AsideNews';
import AsideReferralBanner from '@/views/layouts/sidemenu/AsideReferralBanner';

export default {
  name: 'SideMenu',
  components: {
    AsideReferralBanner, AsideNews, SalesDepartment, CurrencyRates,
  },
};
</script>

<style scoped>

</style>

<i18n>
    {
        "ru": {
            "Мои счета": "Мои счета"
        },
        "en": {
            "Карты": "Cards",
            "Счета": "Accounts",
            "Шаблоны": "Templates",
            "Мои счета": "My accounts",
            "Мои шаблоны": "My templates",
            "Переводы": "Transfer funds",
            "Массовый платеж": "Mass transfer",
            "Пополнение счета": "Deposit",
            "Конвертация": "Currency exchange",
            "Электронные чеки": "Capitalist eVouchers",
            "История операций": "Transactions history",
            "Прием платежей": "Merchant service",
            "Маркетплейс": "Marketplace"
        }
    }
</i18n>
